// extracted by mini-css-extract-plugin
export default {"short-block":"jcDKU","long-block":"IcCP1"};